import React, { useContext } from 'react';
import '../../styles/Perfil.css';
import { ThemeContext } from '../../context/ThemeContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoon, faPalette, faSun } from '@fortawesome/free-solid-svg-icons';

const Configuracoes = () => {
    const { isDarkMode, toggleDarkMode } = useContext(ThemeContext);

    return (
        <div className='container-direito-interno'>
            <div className='perfil-section-header'>
                <span>Ajustes</span>
                <h1>Configurações</h1>
            </div>

            <div className='perfil-card container-opcoes'>
                <div className='container-opcao'>
                    <div className='perfil-info-icon'>
                        <FontAwesomeIcon icon={faPalette} />
                    </div>
                    <div className='perfil-info-content'>
                        <span>Aparência</span>
                        <strong>Modo de cores</strong>
                    </div>
                    <button className='btn-troca-modo' onClick={toggleDarkMode}>
                        <FontAwesomeIcon icon={isDarkMode ? faSun : faMoon} />
                        {isDarkMode ? 'Claro' : 'Escuro'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Configuracoes;
